import React from "react";
import VisibilitySensor from "react-visibility-sensor";
import {
  getRightContent,
  getVisibleSensorAnimation,
  numberWithCommas,
} from "../../assets/js/utils";
import InfoBarDescriptor from "../InfoBarDescriptor";
import InfoDescriptor from "../InfoDescriptor";
import MediaItem from "../MediaItem";
import TableDescriptor from "../TableDescriptor";
import TabSelector from "../TabSelector";
import content from "../../assets/content/content.json";
import { getInfoBarDescriptorFirstAppeareance } from "../../assets/js/content";
import { useSelector } from "react-redux";
import useWindowSize from "../hooks/useWindowSize";
import MediaVertical from "../MediaVertical";
import { awardsImages } from "../../assets/js/images";
import logoBilad from "../../assets/images/logo-bilad.svg";

// const mediaItemIcons = [
//   require("../../assets/images/increase.png"),
//   require("../../assets/images/account-opened.png"),
//   require("../../assets/images/customer-registration.png"),
//   require("../../assets/images/transaction-volume.png"),
//   require("../../assets/images/account-opened.png"),
//   require("../../assets/images/training-seat.png"),
// ];

function Section2(props) {
  const windowWidth = useWindowSize();
  const sections = useSelector((state) => state.ui.sections);
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  return (
    <>
      <div className="center-wrapper">
        <TableDescriptor
          title={
            getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.tableDescriptor1
            ).title
          }
          applyHeightInsteadOfTextAndComponentList="h-150-just-wide-screen"
          // text={
          //   getRightContent(
          //     generalSettings.rtlLanguage,
          //     content.sections[sections.currentSection].content.tableDescriptor1
          //   ).text
          // }
          image={require("../../assets/images/meta.png")}
          secondaryImage={logoBilad}
          // componentsList={[
          //   <InfoDescriptor topText={"ROAA"} unit={"%"} value={1.5} />,
          //   <InfoDescriptor topText={"ROAE%"} unit={"%"} value={13.4} />,
          //   <InfoDescriptor
          //     topText={"Cost to Income"}
          //     unit={"%"}
          //     value={48.5}
          //   />,
          // ]}
          // componentsList={getRightContent(
          //   generalSettings.rtlLanguage,
          //   content.sections[sections.currentSection].content.tableDescriptor1
          // ).componentList.map((infoDesc, index) => (
          //   <InfoDescriptor
          //     key={index}
          //     topText={infoDesc.topText}
          //     unit={infoDesc.unit}
          //     value={infoDesc.value}
          //   />
          // ))}
        />
      </div>
      <div className="flexible-items__container max-width-80">
        {getInfoBarDescriptorFirstAppeareance(sections.currentSection).map(
          (infoBar, index) => (
            <VisibilitySensor partialVisibility key={index}>
              {({ isVisible }) => (
                <div
                  className="flexible-items__item"
                  style={
                    windowWidth > 768
                      ? getVisibleSensorAnimation(
                          isVisible,
                          `fadeIn 1s ${0.75 + index * 0.2}s backwards`
                        )
                      : {}
                  }
                >
                  <InfoBarDescriptor
                    barValues={getRightContent(
                      generalSettings.rtlLanguage,
                      infoBar.barValues
                    )}
                    title={getRightContent(
                      generalSettings.rtlLanguage,
                      infoBar.title
                    )}
                    unit={getRightContent(
                      generalSettings.rtlLanguage,
                      infoBar.unit
                    )}
                    value={numberWithCommas(infoBar.value)}
                    flipIcon={infoBar.flipIcon}
                  />
                </div>
              )}
            </VisibilitySensor>
          )
        )}
      </div>
      <div className="center-wrapper">
        <TableDescriptor
          applyBuildingClassName={"building"}
          title={
            getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.tableDescriptor2
            ).title
          }
          // text={
          //   getRightContent(
          //     generalSettings.rtlLanguage,
          //     content.sections[sections.currentSection].content.tableDescriptor2
          //   ).text
          // }
          image={require("../../assets/images/original-building.png")}
          componentsList={getRightContent(
            generalSettings.rtlLanguage,
            content.sections[sections.currentSection].content.tableDescriptor2
          ).componentList.map((mediaItem, index) => (
            <MediaItem
              key={index}
              bottomText={mediaItem.bottomText}
              value={mediaItem.value}
              topText={mediaItem.topText}
              // icon={mediaItemIcons[index]}
            />
          ))}
          // componentsList={[
          //   <MediaItem
          //     icon={require("../../assets/images/increase.png")}
          //     value={numberWithCommas(173926)}
          //     bottomText={
          //       "Accounts opened digitally in 2020, a 68% increase over 2019"
          //     }
          //   />,
          //   <MediaItem
          //     icon={require("../../assets/images/account-opened.png")}
          //     value={"68%"}
          //     bottomText={
          //       "Increase in account opened digitally over the same period last year"
          //     }
          //   />,
          //   <MediaItem
          //     icon={require("../../assets/images/customer-registration.png")}
          //     value={"79%"}
          //     bottomText={
          //       "Increase in customer registration on online channels"
          //     }
          //   />,
          //   <MediaItem
          //     icon={require("../../assets/images/transaction-volume.png")}
          //     value={"64%"}
          //     bottomText={"Increase in Mobile Banking transactions volume"}
          //   />,
          //   <MediaItem
          //     icon={require("../../assets/images/account-opened.png")}
          //     value={numberWithCommas(32475)}
          //     bottomText={"Customer complaints addressed"}
          //   />,
          //   <MediaItem
          //     icon={require("../../assets/images/training-seat.png")}
          //     value={numberWithCommas(6437)}
          //     bottomText={"Training seats"}
          //   />,
          // ]}
        />
      </div>

      {/* <TabSelector
        tabs={["Our Strategy", "Operatin Review"]}
        contents={[
          <MediaItem
            icon={require("../../assets/images/training-seat.png")}
            value={numberWithCommas(6437)}
            bottomText={"Training seats"}
          />,
          <MediaItem
            icon={require("../../assets/images/account-opened.png")}
            value={numberWithCommas(32475)}
            bottomText={"Customer complaints addressed"}
          />,
        ]}
      /> */}

      {/* <div className="flexible-items__container max-width-80"> */}
      <div className="awards">
        <VisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <div
              className="awards__header"
              style={getVisibleSensorAnimation(
                isVisible,
                "fadeIn 1s backwards"
              )}
            >
              <h2 className="awards__title header general-m">
                {getRightContent(
                  generalSettings.rtlLanguage,
                  content.sections[sections.currentSection].content.awardsBlock
                    .title
                )}
              </h2>
              <div className="award__header-image-container">
                <img
                  src={require("../../assets/images/trophy-cup.png")}
                  alt=""
                  className="awards__header-image"
                  style={getVisibleSensorAnimation(
                    isVisible,
                    "image-appear 1s 0.5s backwards"
                  )}
                />
                <span style={{ height: "20px" }}></span>
                <img
                  src={require("../../assets/images/under-cup.png")}
                  alt=""
                  className="awards__header-image-under-cup"
                  style={getVisibleSensorAnimation(
                    isVisible,
                    "scale-center 1s 0.5s backwards"
                  )}
                />
              </div>
            </div>
          )}
        </VisibilitySensor>

        {/* <div className="flexible-items__container max-width-80 flexible-items__container--baseline ">
          {content.sections[
            sections.currentSection
          ].content.awardsBlock.mediaVertical.map((mediaVer, index) => (
            <VisibilitySensor partialVisibility key={index}>
              {({ isVisible }) => (
                <div
                  className="flexible-items__item"
                  style={
                    windowWidth > 768
                      ? getVisibleSensorAnimation(
                          isVisible,
                          `fadeIn 1s ${0.75 + index * 0.2}s backwards`
                        )
                      : {}
                  }
                >
                  <MediaVertical
                    image={awardsImages[index]}
                    title={getRightContent(
                      generalSettings.rtlLanguage,
                      mediaVer.title
                    )}
                    text={getRightContent(
                      generalSettings.rtlLanguage,
                      mediaVer.text
                    )}
                  />
                </div>
              )}
            </VisibilitySensor>
          ))}
        </div> */}

        <div className="new-awards__container general-m-just-wide-screen">
          <div className="new-awards__labels">
            {getRightContent(
              generalSettings.rtlLanguage,
              content.sections[sections.currentSection].content.awardsBlock
                .newAwardsLabels
            ).map((label, index) => (
              <VisibilitySensor partialVisibility>
                {({ isVisible }) => (
                  <p
                    key={index}
                    className="new-awards__label"
                    style={getVisibleSensorAnimation(
                      isVisible,
                      `fadeIn 1s ${index * 0.2}s backwards`
                    )}
                  >
                    {label}
                  </p>
                )}
              </VisibilitySensor>
            ))}
          </div>
          <div className="new-awards__separator"></div>
          <div className="new-awards__images">
            {awardsImages.map((image, index) => (
              <VisibilitySensor partialVisibility>
                {({ isVisible }) => (
                  <img
                    src={image}
                    key={index}
                    className="new-awards__image"
                    style={getVisibleSensorAnimation(
                      isVisible,
                      `fadeInBright 1s ${index * 0.2}s backwards`
                    )}
                  />
                )}
              </VisibilitySensor>
            ))}
          </div>
        </div>
      </div>
      {/* </div> */}
    </>
  );
}

export default Section2;
